import {
    RecentChats_recentChats_participants,
    RecentChats_recentChats_participants_user,
    RecentChats_viewer,
} from '../__generated__/RecentChats';

function getParticipantNotViewer(
    participantList: RecentChats_recentChats_participants[],
    viewer: RecentChats_viewer
): RecentChats_recentChats_participants[] {
    if (viewer) {
        return participantList.filter(participant => participant.user.id !== viewer.id);
    }
    return participantList;
}

export function getRecipient(
    participantList: RecentChats_recentChats_participants[],
    viewer: RecentChats_viewer
): RecentChats_recentChats_participants_user {
    const nonViewerParticipants = getParticipantNotViewer(participantList, viewer);
    return nonViewerParticipants.length ? nonViewerParticipants[0].user : viewer;
}

export function getParticipantIsViewer(
    participantList: RecentChats_recentChats_participants[],
    viewer: RecentChats_viewer
): RecentChats_recentChats_participants {
    participantList.filter(participant => participant.user.id === viewer.id);
    return participantList[0];
}
